import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MyDatePickerModule } from 'mydatepicker';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NbTabsetModule, NbRouteTabsetModule, NbStepperModule, NbButtonModule, NbListModule, NbAccordionModule, NbUserModule, NbCardModule, NbIconModule, NbInputModule, NbTreeGridModule, NbSpinnerModule } from '@nebular/theme';
import { Ng2SmartTableModule } from 'ng2-smart-table';
import { ThemeModule } from '../../@theme/theme.module';
import { NgxMaskModule } from 'ngx-mask';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { DualListModule } from '../../shared/components/dualList/dual-list.module';
import { FinanceiroRoutingModule } from './financeiro-routing.module';
import { FinanceiroComponent } from './financeiro.component';
import { GestaoFinanceiraComponent } from './gestao-financeira/gestao-financeira.component';
import { ModalBloqueioFinanceiroComponent } from './gestao-financeira/modal-bloqueio-financeiro/modal-bloqueio-financeiro.component';
import { MatChipsModule } from '@angular/material';


@NgModule({
  imports: [
    CommonModule,
    FinanceiroRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    NbTabsetModule,
    NbRouteTabsetModule,
    NbStepperModule,
    NbButtonModule,
    NbListModule,
    NbAccordionModule,
    NbUserModule,
    NbCardModule,
    NbIconModule,
    NbInputModule,
    NbTreeGridModule,
    Ng2SmartTableModule,
    ThemeModule,
    MyDatePickerModule,
    NgxMaskModule.forRoot(),
    NgxDatatableModule,
    NbSpinnerModule,
    DualListModule,
    MatChipsModule,
    NbCardModule,
    NbIconModule,
    MatChipsModule,
  ],
  exports: [
    MyDatePickerModule,
  ],
  declarations: [
   FinanceiroComponent,
   GestaoFinanceiraComponent,
   ModalBloqueioFinanceiroComponent
  ],
  entryComponents: [
    ModalBloqueioFinanceiroComponent,
    GestaoFinanceiraComponent
  ]
})
export class FinanceiroModule { }
